import { AfterViewInit, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
//import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { MessageService } from 'primeng/api';
import { ApiService } from '../../../services/api.service';
import { ActivatedRoute } from '@angular/router';
import { EditorComponent } from '@tinymce/tinymce-angular';
import { init } from '../../editorconfig';
import { Subscription } from 'rxjs';
import { environment } from '../../../../environments/environment';
import tinymce from 'tinymce';
import { getEoiTemplate } from '../../../pre-ready-tepmlate';



@Component({
  selector: 'app-eoi',
  standalone: false,
  templateUrl: './eoi.component.html',
  styleUrl: './eoi.component.scss'
})
export class EOIComponent implements OnInit, OnChanges, AfterViewInit, OnDestroy {
  baseUrl = environment.APIUrl;
  eoiData: any;
  eoiForm: FormGroup;
  reqDoc: any[] = []
  @Input() step: any;
  @Input() id: any
  @Input() getUrl1: any
  @Input() postUrl1: any
  @Input() schemeType: any
  @Output() IRA: EventEmitter<any> = new EventEmitter();
  @Output() generatePDFEmitter: EventEmitter<any> = new EventEmitter();
  @Output() stepCompleted = new EventEmitter<void>();
  @Output() routeConfig: EventEmitter<any> = new EventEmitter();
  @Input() isEditable: boolean = false;
  @Input() stepDetails: any;
  isEditorDisabled: boolean = false;
  init: EditorComponent['init'] = init;
  showEditor = true;
  proposalForm: FormGroup;
  challengeForm: FormGroup;
  payload: {
    proposal_id: any;
    proposal_name: any;
  };
  private subscriptions = new Subscription();
  @Input() masterData: any;
  userID: any;
  constructor(private messageService: MessageService, private fb: FormBuilder, private api: ApiService, private route: ActivatedRoute) {
    this.eoiForm = this.fb.group({
      eoi: ['', Validators.required],
      comment_2: ['', Validators.required],

    });
    const role = sessionStorage.getItem('user_role_id');
    this.userID = role

  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params: any) => {
      const proposalId = params['id'];
      // const proposalStep = params['step'];
      const proposalName = params['name'];
      this.payload = {
        proposal_id: proposalId,
        // proposal_step:proposalStep,
        proposal_name: proposalName
      }
      // Don't make API calls here - wait until component is actually displayed
    });
    //console.log("masterdata", this.masterData)
  }

  ngOnChanges(changes: SimpleChanges): void {
    // Only make API calls when component is actually displayed (when id or step changes and are valid)
    // Note: payload is set in ngOnInit, so we check here but actual calls happen in ngAfterViewInit
    // This prevents calls when component is being destroyed or not yet ready
    if ((changes['id'] || changes['step']) && this.id && this.payload?.proposal_id) {
      // If id changed (not first change, meaning step was switched), reload data
      if (!changes['id']?.firstChange && !changes['step']?.firstChange) {
        if (changes['id']?.currentValue !== changes['id']?.previousValue) {
          this.getStep1();
        }
      }
      // For first change, we'll handle in ngAfterViewInit to ensure payload is set
    }
  }
  ngAfterViewInit() {
    // Make API calls here if component is active and payload is set
    // This ensures we only make calls when component is actually displayed in the DOM
    if (this.id && this.payload?.proposal_id && this.getUrl1 && !this.eoiData) {
      this.getStep1();
    }
    setTimeout(() => {
      if (this.stepDetails?.can_edit || this.isEditable) {
        this.isEditorDisabled = false;
        this.eoiForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.eoiForm.disable();
      }
      this.rebuildEditor()
    }, 3000);
  }
  editorReady = false;
  rebuildEditor() {
    this.editorReady = false; // destroy
    setTimeout(() => {
      this.init = this.getTinyInit(); // refresh config
      this.editorReady = true; // recreate editor
    }, 0);
  }
  getTinyInit(): EditorComponent['init'] {
    return {
      readonly: this.isEditorDisabled
    };
  }
  ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }
  goToNextStep() {
    this.stepCompleted.emit();
  }

  getStep1() {
    // Guard: Only make API call if component is active and has required data
    if (!this.id || !this.payload?.proposal_id || !this.getUrl1) {
      return;
    }
    const sub = this.api.getAPI(this.getUrl1 + this.id + '&proposal_step__proposal=' + this.payload.proposal_id).subscribe((res: any) => {
      this.eoiData = res[0];
      // Conditionally enable/disable based on edit rights instead of always disabling
      if (this.stepDetails?.can_edit || this.isEditable) {
        this.isEditorDisabled = false;
        this.eoiForm.enable();
      } else {
        this.isEditorDisabled = true;
        this.eoiForm.disable();
      }
      // If no saved data exists, set the default EOI template
      if (!res[0]?.eoi) {
        this.eoiForm.patchValue({
          eoi: getEoiTemplate(),
        });
      } else {
        this.patchFormValues(res[0]);
      }
      this.reqDoc = res[0]?.criteria_list;
      // Rebuild editor after form state is set
      this.rebuildEditor();
      // this.initializeComplianceData();
    })
    this.subscriptions.add(sub);
  }

  patchFormValues(data: any) {
    this.eoiForm.patchValue({
      eoi: data?.eoi || '',
      comment_2: data?.proforma || ''
    });

    this.showEditor = false;

    // Update the init before triggering re-render
    setTimeout(() => {
      this.init = {
        ...this.init,
        content_css: environment.APIUrl + data?.css_file_path
      };
      this.showEditor = true;
    }, 0);
  }


  addRow() {
    if (!this.reqDoc) {
      this.reqDoc = [];
    }

    this.reqDoc.push({
      srNo: this.reqDoc.length + 1,
      name: '',
      edit: true,
    });
  }


  generatePDF() {
    const payload = {
      url: '/revenue/need/version-control/',
      data: [
        { key: "EoI ", value: this.eoiForm.get('eoi').value },
        { key: "EoI Preforma ", value: this.eoiForm.get('comment_2').value },
        { key: "DOCUMENTS/INFORMATION TO BE SUBMITTED AS PART OF RESPONSES TO EoI : AN ILLUSTRATIVE LIST  ", value: "<p></p>" },
        ...this.reqDoc.map((item, index) => ({ key: ` ${index + 1}`, value: item.name })),
      ]
    }
    this.generatePDFEmitter.emit(payload);
  }
  submitStep() {
    const selectedData = this.masterData.find(item => item.name === 'EOI');

    let payload = {
      proposal_step: this.id,
      eoi: this.eoiForm.get('eoi').value,
      proforma: this.eoiForm.get('comment_2').value,
      css_file_path: selectedData?.style || '',
      criteria_list: this.reqDoc,
      status: '1'
    }
    if (this.eoiData?.id) {
      const sub = this.api.putAPI(`${this.postUrl1}${this.eoiData.id}/`, payload).subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message || 'EOI submitted successfully'
          });
          this.getStep1();
          // this.routeConfig.emit({ isRouteConfig: true });
        },
        error: (err) => {
          console.error('Error updating EOI:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || 'Failed to save EOI'
          });
        }
      });
      this.subscriptions.add(sub);
    } else {
      const sub = this.api.postAPI(`${this.postUrl1}`, payload).subscribe({
        next: (res: any) => {
          this.messageService.add({
            severity: 'success',
            summary: 'Success',
            detail: res.message || 'EOI submitted successfully'
          });
          this.getStep1();
          // this.routeConfig.emit({ isRouteConfig: true });
        },
        error: (err) => {
          console.error('Error saving EOI:', err);
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err?.error?.detail || 'Failed to save EOI'
          });
        }
      });
      this.subscriptions.add(sub);
    }
  }



  // fetchMasterData() {
  //   const selectedData = this.masterData.find(item => item.name === 'EOI');
  //   if (selectedData) {
  //     const styleUrl = environment.APIUrl + selectedData.style;
  //     this.init={
  //       ...this.init,
  //       content_css:styleUrl
  //     }
  //     this.showEditor = false;
  //     setTimeout(() => {
  //       this.showEditor = true;
  //     });
  //     this.eoiForm.patchValue({
  //       comment: selectedData.paragraph_1 || '',
  //       comment_2: selectedData.paragraph_2 || '',
  //     });
  // 
  //     //console.log('Style URL used:', styleUrl);
  //   }
  // }

}